module.exports = __webpack_public_path__ + "static/media/Boxed_Icon_Shadow@2x.0942d0a4.png";